<div class="header header-bg">
    <div class="nav-container">

        <div class="menu-button">
            <span class="k-icon hamburger-icon" (click)="onButtonClick()"></span>
        </div>

        <div class="title">
            <a (click)="onclick()">
                <img src="../../../assets/Logo_MicroioInovacao_2025_v1_branco.png" alt="Logo"
                    style="width: 13%; height: auto;">
            </a>
        </div>

        <!-- Balão de texto com o componente -->
        <div *ngIf="showInfoBalloon" class="info-balloon">
            <app-versoes-component></app-versoes-component>
        </div>

        <!-- Botão de informação -->
        <div>
            <button style="background-color: transparent; border: none; margin-left: 12px;"
                (click)="toggleInfoBalloon()"><span class="k-icon k-i-information"
                    style="color: white;"></span></button>
        </div>

        <div class="settings">
            <kendo-stacklayout [gap]="15" orientation="horizontal">
                <kendo-stacklayout [gap]="1" orientation="vertical">
                    <kendo-menu>
                        <kendo-menu-item text="">
                            <ng-template kendoMenuItemTemplate>
                                <app-profile-image [fullName]="userName"></app-profile-image>
                            </ng-template>

                            <!-- userName e userDescricaoFuncao -->
                            <kendo-menu-item text="" [disabled]="true">
                                <ng-template kendoMenuItemTemplate>
                                    <div>
                                        <span class="k-icon k-i-user"></span>
                                        <span class="optionUserPerfil"> {{userName}} | {{userType}}</span>
                                    </div>
                                </ng-template>
                            </kendo-menu-item>

                            <!-- alterarPassword -->
                            <kendo-menu-item text="">
                                <ng-template kendoMenuItemTemplate>
                                    <div>
                                        <span class="k-icon k-i-edit"></span>
                                        <a icon="edit" (click)="changePass()">{{
                                            customMsgService.translate('alterarPassword') }}</a>
                                    </div>
                                </ng-template>
                            </kendo-menu-item>



                            <kendo-menu-item text="">
                                <ng-template kendoMenuItemTemplate>
                                    <div>
                                        <span class="k-icon k-i-logout"></span>
                                        <a href="" kendoButton icon="logout" (click)="logOut()">{{
                                            customMsgService.translate('terminarSessao') }}</a>
                                    </div>
                                </ng-template>
                            </kendo-menu-item>
                        </kendo-menu-item>

                    </kendo-menu>
                </kendo-stacklayout>
            </kendo-stacklayout>
        </div>
    </div>
</div>